'use client';

import { c as _c } from "react/compiler-runtime";
import { StatsCard } from '@/shared/components/ui';
import { formatCurrency } from '@/shared/formatters';
import { FeatherActivity, FeatherAlertCircle, FeatherDollarSign, FeatherTrendingUp } from '@subframe/core';
import type { LoteDashboardStatsProps } from '../../types/lote.types';
export function LoteDashboardStats(t0) {
  const $ = _c(23);
  const {
    metrics
  } = t0;
  let t1;
  if ($[0] !== metrics.total) {
    t1 = metrics.total.toString();
    $[0] = metrics.total;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherActivity className="text-brand-600 h-4 w-4" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <StatsCard label={"Total de Negocia\xE7\xF5es"} value={t1} icon={t2} />;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== metrics.intervention) {
    t4 = metrics.intervention.toString();
    $[5] = metrics.intervention;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherAlertCircle className="text-warning-600 h-4 w-4" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <StatsCard label={"Interven\xE7\xE3o Humana"} value={t4} icon={t5} />;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `${metrics.conversionRate}%`;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherTrendingUp className="text-success-600 h-4 w-4" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <StatsCard label={"Taxa de Convers\xE3o"} value={t7} icon={t8} />;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== metrics.totalValue) {
    t10 = formatCurrency(metrics.totalValue, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    $[13] = metrics.totalValue;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FeatherDollarSign className="text-brand-600 h-4 w-4" />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10) {
    t12 = <StatsCard label={"Valor em Negocia\xE7\xE3o"} value={t10} icon={t11} />;
    $[16] = t10;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t3 || $[20] !== t6 || $[21] !== t9) {
    t13 = <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">{t3}{t6}{t9}{t12}</div>;
    $[18] = t12;
    $[19] = t3;
    $[20] = t6;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}